<script lang="ts">

  let { class: className = "" } = $props()
</script>

<svg class={className} height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M320-400v-160h136.92L600-703.08v446.16L456.92-400H320Zm40-40h114l86 86v-252l-86 86H360v80Zm100-40Z"/></svg>